// eslint-disable-next-line css-modules/no-unused-class
import { FullCommunityQuestion, FullEvent, FullPost } from 'model';
import { ReactNode } from 'react';
import { FormValueType } from '../../hooks/useFormValues';
import { InlineImageUpload } from '../InlineImageUpload';
// eslint-disable-next-line css-modules/no-unused-class
import formStyles from './FormFields.module.css';

interface FormInlineImageAreaProps {
	children: ReactNode;
	setValues: (value: FormValueType<{ contents: string }>) => void;
	content?: string;
	document: FullPost | FullEvent | FullCommunityQuestion;
}
export const FormInlineImageArea: React.FC<FormInlineImageAreaProps> = ({ children, setValues, document, content }) => {
	const onAddInline = (inlineString: string) => {
		const currentContents = content || '';
		const newContents = `${currentContents}\n${inlineString}`;
		setValues({
			contents: newContents
		});
	};
	return (
		<div className="relative">
			<div className={formStyles.inlineImageIconContainer}>
				<div className={formStyles.inlineImageIcon}>
					<InlineImageUpload post={document} action={onAddInline} />
				</div>
			</div>
			{children}
		</div>
	);
};
